import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import NavLink from '../NavLink';
import messages from '../../locale/messages';
import Link from '../Link';
import { connect } from 'react-redux';
import cx from 'classnames';
import { api, logoUploadDir } from '../../config'
import { flowRight as compose } from 'lodash';
import history from '../../history';
import HeaderModal from '../HeaderModal/HeaderModal';
import { openHeaderModal } from '../../actions/siteadmin/modalActions';
import { formatLocale } from '../../helpers/formatLocale';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';
import LanguageIcon from '../../../public/Icons/languageIcon.svg';

//images
import selectedLightIcon from '../../../public/Icons/lightModeOn.svg';
import selectedDarkIcon from '../../../public/Icons/darkModeOn.svg';
import dropDownLightIcon from '../../../public/Icons/lightModeOff.svg';
import dropDownDarkIcon from '../../../public/Icons/darkModeOff.svg';

//Styles
import s from './Header.css';



class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      isOpen: 0,
    };
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
  }

  componentDidMount() {
    this.setState({
      location: history.location.pathname
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    if (prevState.location !== location) {
      this.setState({
        location
      })
    }
  }

  async openMenu() {
    this.setState({
      isOpen: 1,
    })
  }
  async openClose() {
    this.setState({
      isOpen: 0,
    })
  }

  handleChange(e) {
    const { openHeaderModal } = this.props;
    openHeaderModal('languageModal');
  }



  render() {
  
    const { location } = this.state;
    const { logo, siteName, isOpen, currentLocale, selectedTheme, choseToTheme, darkHome } = this.props;

    return (
      <div className={cx(s.root, 'mainMenu', darkHome, 'homeNav')}>
        <HeaderModal />
        <Navbar expand="lg" className={cx(s.navBg, { ['homeHeader']: location === '/' || location === '/home' })}>
          <Navbar.Brand>
            <Link className={s.brand} to="/">
              <img
                src={api.apiEndpoint + logoUploadDir + logo}
                alt={siteName}
                className={s.logoImg}
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className={cx(s.borderNone, s.outlineNone)}
            children={
              <div className={'menuToggle'} onClick={() => this.openMenu()}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            }
          />
          <Navbar.Collapse className={cx({ ['menuOpened']: this.state.isOpen == 1 }, s.justifyFlexEnd, 'menuClosed')}
            in={isOpen} id="basic-navbar-nav">
            <Nav className={cx(s.navigationLink, 'navigationLinkDark')} onClick={() => this.openClose()}>
              <div className={cx(s.closeButton, 'closeButtonHomeRTL')}> &#x2715; </div>
              <NavDropdown title={
                <>
                  {
                    (selectedTheme && selectedTheme === "light") &&
                    <span className={s.selectedThemeColor}> <img src={selectedLightIcon} alt='' /> <FormattedMessage {...messages.lightMode} /></span>
                  }
                  {
                    (selectedTheme && selectedTheme === "dark") &&
                    <span className={s.selectedThemeColorDark}> <img src={selectedDarkIcon} alt='' /> <FormattedMessage {...messages.darkMode} /></span>
                  }
                </>
              }
                noCaret id="basic-nav-dropdown1" className={cx(s.nonBreakPointScreen, 'themeIconDropDown', s.showWebViewOnly)}>
                <NavDropdown.Item to="#" onClick={() => { choseToTheme('light') }} className={s.themeIconDropDownLink}>
                  <div className={cx({ [s.selectedThemeColor]: selectedTheme === "light" }, s.themeIconSec)}>
                    {
                      (selectedTheme && selectedTheme === "light") ?
                        <img src={selectedLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> : <img src={dropDownLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                    }
                    <FormattedMessage {...messages.lightMode} />
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item to="#" onClick={() => { choseToTheme('dark') }} className={s.themeIconDropDownLink}>
                  <div className={cx({ [s.selectedThemeColor]: selectedTheme === "dark" }, s.themeIconSec)}>
                    {
                      (selectedTheme && selectedTheme === "dark") ?
                        <img src={selectedDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> : <img src={dropDownDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                    }
                    <FormattedMessage {...messages.darkMode} />
                  </div>
                </NavDropdown.Item>
              </NavDropdown>
              <NavLink noLink onClick={(e) => this.handleChange(e)} className={cx('svgImg', s.languageIconSection)}>
                <img src={LanguageIcon} className={s.languageIcon} />
                <span>
                  {formatLocale(currentLocale)}
                </span>
              </NavLink>
              <NavLink to="/" className={cx({['activeMenu']: location === '/' })}><FormattedMessage {...messages.homeonly} /></NavLink>
              <NavLink to="/user" className={cx({['activeMenu']: location === '/user' })}><FormattedMessage {...messages.user} /></NavLink>
              <NavLink to="/partner" className={cx({['activeMenu']: location === '/partner' })}><FormattedMessage {...messages.partner} /></NavLink>
              <NavLink to="/support" className={cx({['activeMenu']: location === '/support' })}><FormattedMessage {...messages.contact} /></NavLink>
              <NavLink to="#" onClick={() => { choseToTheme('light') }} className={s.showMobileViewOnly}>
                <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "light" })}>
                  <FormattedMessage {...messages.lightMode} />
                  {
                    selectedTheme && selectedTheme === "light" ?
                      <img src={selectedLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> :
                      <img src={dropDownLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                  }
                </span>
              </NavLink>
              <NavLink to="#" onClick={() => { choseToTheme('dark') }} className={s.showMobileViewOnly}>
                <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "dark" })}>
                  <FormattedMessage {...messages.darkMode} />
                  {
                    selectedTheme && selectedTheme === "dark" ?
                      <img src={selectedDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> :
                      <img src={dropDownDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                  }
                </span>
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}

const mapState = (state) => ({
  logo: state?.siteSettings?.data?.homeLogo,
  siteName: state?.siteSettings?.data?.siteName,
  currentLocale: state.intl.locale,
  selectedTheme: state.currency.theme
})
const mapDispatch = {
  openHeaderModal,
  choseToTheme
}

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch)
)(Header)
